import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { AuthProvider } from "react-oidc-context"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

const options = {  
  position: positions.MIDDLE,
  timeout: 8000,
  offset: '30px',
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 10000
  }
}

const oidcConfig = {
  authority: `${process.env.REACT_APP_OIDC_AUTHORITY}`,
  client_id: `${process.env.REACT_APP_OIDC_CLIENT_ID}`,
  redirect_uri: `${process.env.REACT_APP_OIDC_REDIRECT_URI}`,
  post_logout_redirect_uri: `${process.env.REACT_APP_OIDC_POST_LOGOUT_URI}`,
  response_type: 'code',
  scope: 'openid'
}

//scope: 'openid profile roles holder'

ReactDOM.render(
  
    
  
      <AlertProvider template={AlertTemplate} {...options}>
        <AuthProvider {...oidcConfig}>
          <App></App>
        </AuthProvider>
      </AlertProvider>,
  
    
  
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
